import {Locales} from '@netx/core-next/locales/utils/Locales';

export const SEARCH_VISUAL_ACTION_LABELS = Locales((i18n) => ({
	ASSET: i18n('i18n.findAssetsLikeThis'),
}));
